import { CookieConsentContent } from '@src/app/shared/typings/analytics.js'

export function parseCookieConsentString(cookieString?: string): CookieConsentContent | undefined {
  if (!cookieString) {
    return undefined
  }
  return (
    cookieString
      .substring(1, cookieString.length - 1)
      .split(',')
      // eslint-disable-next-line unicorn/no-array-reduce
      .reduce((res: any, c: string) => {
        const [key, val] = c.split("'").join('').trim().split(':')
        try {
          return Object.assign(res, { [key!]: JSON.parse(val!) })
        } catch {
          return Object.assign(res, { [key!]: val })
        }
      }, {})
  )
}
